import { PersoenlichesSchema } from '@/domain/mitarbeiter/features/anlageassistent/schema/personSchema';
import { SubStepKey } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import z from 'zod';

export const FormSchema = z.object({
  person: z.object({
    persoenliches: PersoenlichesSchema,
  }),
});

export const subStepSchemasMap = {
  'person.persoenliches': FormSchema.shape.person.shape.persoenliches,
} satisfies Record<SubStepKey, z.ZodTypeAny>;
